import { render, staticRenderFns } from "./broadcast-icon.svg.vue?vue&type=template&id=6ddefa02&"
import script from "./broadcast-icon.svg.vue?vue&type=script&lang=js&"
export * from "./broadcast-icon.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports